import React, { useState, useEffect, useMemo } from "react";
import { IS_SERVER } from "@/res/helpers/ServiceHelper";
import useIsomorphicLayoutEffect from "@/res/hooks/UseIsomorphicLayoutEffect";
import queryString from "query-string";
import ContentDefault from "@/res/components/ClientCreate/content-default";
import ContentInDev from "@/res/components/ClientCreate/content-indev";
import ContentSales from "@/res/components/ClientCreate/content-sales";

const ClientCreate = (props) => {
    const [isSales] = useState(IS_SERVER ? false : ["sales", "sale"].includes(window.location.hostname.split(".")[0].toLowerCase()));
    const [inDevelopment, setDevelopment] = useState(false);
    const [isMultiMode, setMultiMode] = useState(false);
    const [isSearchable, setSearchable] = useState(false);
    const [isAmlEnabled, setAml] = useState(false);
    const [urlParams, setUrlParameters] = useState({});

    const [details] = useState(props?.details);

    const pkg = useMemo(() => {
        return {
            isSales,
            inDevelopment,
            isMultiMode,
            isSearchable,
            isAmlEnabled,
            urlParams,
            details,
            ...props,
        };
    }, [details, props, isSales, isSearchable, inDevelopment, isMultiMode, isAmlEnabled, urlParams]);

    useIsomorphicLayoutEffect(() => {
        if (IS_SERVER) return;

        let params = queryString.parse(location.search);
        setUrlParameters(params);
    }, []);

    useEffect(() => {
        setMultiMode(details?.settings?.multi_mode ?? false);
        setDevelopment(details?.settings?.in_development ?? false);
        setSearchable(details?.settings?.lookup ?? false);
        setAml(details?.settings?.aml_enabled ?? false);
    }, [details]);

    if (inDevelopment && !isSales) return <ContentInDev {...pkg}/>
    if (isSales) return <ContentSales {...pkg}/>
    return <ContentDefault {...pkg}/>;
}

export default ClientCreate;
